import React from 'react';
import {
  BrowserRouter as Router, Route, Routes
} from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
//page
import Home from './Home';
import Generique from './Generique';
import Pitch from './Pitch';
import Teaser from './Teaser';
import Calendrier from './Calendrier';
import Ensavoirplus from './EnSavoirPlus';
import Jugement from './Jugement';
import JugementBordeaux from './JugementBordeaux';
import JugementParisLundi from './JugementParisLundi';
import JugementParisMardi from './JugementParisMardi';
import JugementParisJeudi from './JugementParisJeudi';
import JugementParisVendredi from './JugementParisVendredi';
import JugementParisSamedi from './JugementParisSamedi';
import JugementLyonMardi from './JugementLyonMardi';
import JugementLyonMercredi from './JugementLyonMercredi';
import Redirection from './Redirection';


const App = () => {
  
  return (
    <>

      <Router>
      <ScrollToTop />
          <Routes>
            <Route index element={<Home />} />
            <Route path="generique" element={<Generique />}  />
            <Route path="pitch" element={<Pitch />}  />
            <Route path="teaser" element={<Teaser />}  />
            <Route path="calendrier" element={<Calendrier />}  />
             <Route path="en-savoir-plus" element={<Ensavoirplus />}  />
            <Route path="devenez-jure" element={<Jugement />}  />
            <Route path="devenez-jure/bordeaux-24/01/24" element={<JugementBordeaux />}  />
            <Route path="devenez-jure/paris-24/11/25" element={<JugementParisLundi />}  />
            <Route path="devenez-jure/paris-25/11/25" element={<JugementParisMardi />}  />
            <Route path="devenez-jure/paris-27/11/25" element={<JugementParisJeudi />}  />
            <Route path="devenez-jure/paris-28/11/25" element={<JugementParisVendredi />}  />
            <Route path="devenez-jure/paris-29/11/25" element={<JugementParisSamedi />}  />
            <Route path="devenez-jure/lyon-09/12/25" element={<JugementLyonMardi />}  />
            <Route path="devenez-jure/lyon-10/12/25" element={<JugementLyonMercredi />}  />
            
            <Route path="/redirection" element={<Redirection />} />
            
          </Routes>
      </Router>
    </>
  );
};

export default App;